module.exports = __webpack_public_path__ + "assets/TorricelliPt.f01f6daf177b426ecbd6b1c45bc6eef8.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TorricelliPt.gmt
// module id = 1018
// module chunks = 0